<template>
  <div class="row w-100" style="z-index: 9" v-if="visible">
    <div class="col">
      <p class="mb-0">
        <b>Email address required</b>
        <br />
        Just let us know the email for
        <span class="text-capitalize">{{ practice.name }}</span>
      </p>
      <small>
        <a v-show="!isAdded" href="javascript:void(0)" @click.stop="EmailUnknown">I don't know their email</a>
      </small>
    </div>
    <div class="col d-flex align-items-center">
      <span v-if="isAdded" class="text-success mx-auto font-weight-bold d-flex align-items-center">
        <font-awesome-icon icon="check-circle" size="2x" class="mr-2" />Added!
      </span>
      <div v-else class="input-group input-group-lg">
        <input type="email" ref="emailField" v-model="email" class="form-control" :placeholder="`Provide their email address`" autofocus @keyup.enter="addToNetwork" :data-v-type="practice.is_example ? 'examplePracticeAdd' : ''" />
        <div class="input-group-append">
          <button @click="addToNetwork" class="btn btn-primary" :data-v-tour="practice.is_example ? 'examplePracticeAddButton' : ''">
            <font-awesome-icon icon="spinner-third" spin v-if="isSending" :disabled="isSending" />
            <span v-else>Finish</span>
          </button>
        </div>
      </div>
    </div>
    <font-awesome-icon :icon="['far', 'times']" @click.stop="$emit('close')" style="position: absolute; top: 0; right: 0; cursor: pointer" class="text-muted" />
    <suggested-practice-modal v-if="emailMatchedExistingPractice" :practice="emailMatchedExistingPractice" @close="emailMatchedExistingPractice=null" @selected="existingSelected" />
  </div>
</template>
<script>
import invitePreviewImg from '@/assets/invite_preview.png'
import SuggestedPracticeModal from './SuggestedPracticeModal.vue'
import { mapGetters } from 'vuex'
export default {
  components: { SuggestedPracticeModal },
  props: ['practice', 'visible', 'preventInvite', 'redirect'],
  data() {
    return {
      isSending: false,
      isAdded: false,
      email: '',
      invitePreview: invitePreviewImg,
      emailMatchedExistingPractice: null,
    }
  },
  computed: {
    ...mapGetters('practices', ['network']),
    boundEmail: {
      get() {
        return this.practice.is_example ? this.practice.email : this.email
      },
      set(v) {
        this.email = v
      },
    },
  },
  methods: {
    EmailUnknown() {
      this.$track('$email_unknown', {
        event_category: 'AddToNetwork',
        event_label: this.preventInvite
          ? 'SuggestedCreateReferral'
          : 'BuildNetwork',
      })
      // this.$gtag.event('email_unknown', {
      //   event_category: 'AddToNetwork',
      //   event_label: this.preventInvite
      //     ? 'SuggestedCreateReferral'
      //     : 'BuildNetwork',
      // })
      this.$emit('close')
    },
    async addToNetwork() {
      if (this.practice.is_example) {
        this.$emit('adding', { practice: this.practice })
        this.$emit('added', {
          practice: this.practice,
          network: this.practice,
        })
        await this.$store.commit('suggested/removeTour')
        return
      }
      if (!this.email || !this.$refs.emailField.checkValidity()) return
      this.$track('$added', {
        event_category: 'AddToNetwork',
        event_label: this.preventInvite
          ? 'SuggestedCreateReferral'
          : 'BuildNetwork',
      })
      // try {
      //   this.$gtag.event('added', {
      //     event_category: 'AddToNetwork',
      //     event_label: this.preventInvite
      //       ? 'SuggestedCreateReferral'
      //       : 'BuildNetwork',
      //   })
      // } catch (e) {
      //   /*gulp*/
      // }
      try {
        this.practice.email = this.email
        this.$emit('adding', { practice: this.practice })
        this.isSending = true
        const network = await this.$store.dispatch('practices/addToNetwork', {
          ...this.practice,
        })
        this.$emit('added', { practice: this.practice, network })
        this.isAdded = true
        if (!this.preventInvite)
          await this.$store.dispatch('invites/save', {
            email: this.practice.email,
            practice: this.practice,
          })
      } catch (err) {
        if (err?.errors?.existing) {
          this.emailMatchedExistingPractice = err?.errors?.existing
        } else {
          this.$helpers.handleApiError(this)(err)
        }
      }
      this.isSending = false
    },
    async existingSelected() {
      //todo: check if emailMatechExisitingPractice is already in network
      const isInNetwork = this.network.some(
        (p) => p.id == this.emailMatchedExistingPractice.id
      )
      if (isInNetwork) {
        if (this.redirect)
          this.$router.push(
            `/${this.redirect}/?to=${this.emailMatchedExistingPractice.id}`
          )
        return
      }
      const network = await this.$store.dispatch('practices/addToNetwork', {
        ...this.emailMatchedExistingPractice,
      })
      this.$emit('added', {
        practice: this.emailMatchedExistingPractice,
        network,
      })
    },
  },
}
</script>
<style scoped></style>
